<template>
    <v-container fluid>
        <fulldialog
            v-bind:timerContainer="timer" 
            v-bind:partesContainer="partes" 
            v-bind:tecnicos="tecnicos" 
            v-bind:contratosContainer="contratos"
            v-bind:ambitos="ambitos"
            v-bind:fecha="fecha"
            v-bind:comentarios="comentarios"
            v-bind:gradosurgencia="gradosurgencia"
            v-bind:comerciales="comerciales"
            v-bind:delegaciones="delegaciones"
            v-if="dialog"
        />
        <fulldialogTimergrupo 
            v-bind:contratos="contratos"
            v-bind:ambitos="ambitos"
            v-bind:comentarios="comentarios"
            v-bind:gradosurgencia="gradosurgencia"
            v-if="dialogG"
        />
        <div v-if="!dialog && !dialogG">
            <template v-if="!timers.length && !timersGrupos.length">
                <v-row>      
                    <v-col cols="12">
                        <center>
                            <v-img width="25%" style="opacity: .4" src="img/svg/chilling.svg"></v-img>
                            <span class="text--disabled font-italic text-xs-subtitle-1 text-md-h6">Nada por aquí...</span>     
                        </center>
                    </v-col>
                </v-row>  
            </template>
            
            <v-card v-if="timers.length > 0 || timersGrupos.length > 0">
                <v-tabs v-model="tab" grow show-arrows>
                    <v-tab :disabled="splitTimers('hoy')[2] === 0">
                        Hoy <v-chip color="info ml-2 pa-2" small outlined>{{splitTimers('hoy')[2]}}</v-chip>
                        <v-icon v-if="contieneTimerActivo === 'hoy'" class="parpadea">mdi-clock-time-three-outline</v-icon>
                    </v-tab>
                    <v-tab :disabled="splitTimers('ayer')[2] === 0">
                        Ayer <v-chip color="warning ml-2 pa-2" small outlined>{{splitTimers('ayer')[2]}}</v-chip>
                        <v-icon v-if="contieneTimerActivo === 'ayer'" class="parpadea">mdi-clock-time-three-outline</v-icon>
                    </v-tab>
                    <v-tab :disabled="splitTimers('anteriores')[2] === 0">
                        Anteriores <v-chip color="error ml-2 pa-2" small outlined>{{splitTimers('anteriores')[2]}}</v-chip>
                        <v-icon v-if="contieneTimerActivo === 'anteriores'" class="parpadea">mdi-clock-time-three-outline</v-icon>
                    </v-tab>
                </v-tabs>
                
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <timerGrupo v-for="timerGrupo in splitTimers('hoy')[1]" :key="timerGrupo.id" v-bind:contieneTimerActivo="contieneTimerActivo"/>
                                <timer v-for="timer in splitTimers('hoy')[0]" :key="timer.id" v-bind:contieneTimerActivo="contieneTimerActivo"/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <timerGrupo v-for="timerGrupo in splitTimers('ayer')[1]" :key="timerGrupo.id" v-bind:contieneTimerActivo="contieneTimerActivo"/>
                                <timer v-for="timer in splitTimers('ayer')[0]" :key="timer.id" v-bind:contieneTimerActivo="contieneTimerActivo"/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <timerGrupo v-for="timerGrupo in splitTimers('anteriores')[1]" :key="timerGrupo.id" v-bind:contieneTimerActivo="contieneTimerActivo"/>
                                <timer v-for="timer in splitTimers('anteriores')[0]" :key="timer.id" v-bind:contieneTimerActivo="contieneTimerActivo"/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card> 

            <v-speed-dial v-model="fab" fixed direction="top" transition="slide-y-reverse-transition" style="bottom: 37px; right: 30px;">
                <template v-slot:activator>
                    <v-btn v-model="fab" color="teal lighten-1" dark fab>
                        <v-icon v-if="fab">mdi-close</v-icon>
                        <v-icon v-else>mdi-plus</v-icon>
                    </v-btn>
                </template>
            
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab dark small color="indigo" @click="dialogEscogerCliente=true; ejecutarFoco('inputClientes')">
                            <v-icon>mdi-timer-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Nuevo timer</span>
                </v-tooltip>

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab dark small color="deep-purple lighten-1" @click="dialogEscogerGrupo=true; ejecutarFoco('inputGrupos')">
                            <v-icon>mdi-timetable</v-icon>
                        </v-btn>
                    </template>
                    <span>Nuevo timer de grupo</span>
                </v-tooltip>

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab dark small color="light-blue" @click="guardar()">
                            <v-icon>mdi-content-save-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Guardar timers</span>
                </v-tooltip>

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab dark small color="green" @click="imputarTodosTimers()">
                            <v-icon>mdi-calendar-check</v-icon>
                        </v-btn>
                    </template>
                    <span>Imputar todos los timers</span>
                </v-tooltip>
            </v-speed-dial> 
            
            <v-dialog v-model="dialogEscogerCliente" persistent max-width="600px">
                <v-card>
                    <v-card-title><span class="headline">Cliente</span></v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete 
                                        :loading="loading" 
                                        :disabled="loading" 
                                        v-model="clienteSeleccionado" 
                                        :items="clientes" 
                                        chips 
                                        label="Selecciona" 
                                        item-text="name" 
                                        item-value="name" 
                                        return-object
                                        ref="inputClientes"
                                        autofocus 
                                        @change="pressEnter()"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEscogerCliente=false, clienteSeleccionado = {}">Cerrar</v-btn>
                        <v-btn color="blue darken-1" text :disabled="this.$v.clienteSeleccionado.$invalid" @click="nuevoTimer()" ref="anadir">
                            Añadir
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog> 

            <v-dialog v-model="dialogEscogerGrupo" persistent max-width="600px">
                <v-card>
                    <v-card-title><span class="headline">Grupo</span></v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete 
                                        :loading="loading" 
                                        :disabled="loading" 
                                        v-model="grupoSeleccionado" 
                                        :items="grupos" 
                                        chips
                                        label="Selecciona" 
                                        item-text="nombre" 
                                        return-object
                                        ref="inputGrupos"
                                        autofocus
                                        @change="pressEnter()"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEscogerGrupo=false, grupoSeleccionado = {}">Cerrar</v-btn>
                        <v-btn color="blue darken-1" text :disabled="this.$v.grupoSeleccionado.$invalid" @click="nuevoTimerGrupo()" ref="anadir">
                            Añadir
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog> 
            
            <v-footer absolute class="infoGuardado">
                <span v-if="horaGuardado !== ''">Guardado a las {{horaGuardado}}</span>
            </v-footer>  
        </div>
    </v-container>     
</template>

<script>
import Timer from './Timer';
import TimerGrupo from './TimerGrupo';
import FullDialog from './FullDialog';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import FullDialogTimerGrupo from './FullDialogTimerGrupo.vue';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
    name: 'Arditimer',
    data: () => ({
        fab: false,
        loading: false,
        clientes: [],
        dialogEscogerCliente: false,
        dialogEscogerGrupo: false,
        clienteSeleccionado: {},
        grupoSeleccionado: {},
        interval: null,
        tab: null,
        cantidadTimers: {
            hoy: 0,
            ayer: 0,
            anteriores: 0
        },
        grupos:[],
        eventoCierre: null,

        //DATOS FULLDIALOG
        timer: {},
        fecha: '', 
        comentarios: '',
        ambitos: [],
        contratos: [],
        gradosurgencia:[],
        partes: [],
        tecnicos: [],
        comerciales: [],
        delegaciones: [],
        primeroImputarTodos: false
    }),
    methods: {
        ...mapActions(['setLoading', 'setSnackbar']),
        ...mapActions('arditimer', ['setHoraGuardado', 'setTimers', 'setTimersGrupo', 'setNuevoTimer', 'setDialog', 'setIdTimerActivo', 'setAutoGuardado', 'setTabConTimerActivo', 'setImputarTodos', 'setNuevoTimerGrupo', 'setCargarDatosDialog', 'setCopiaCantidadTimersTotal', 'setCantidadTimersTotal', 'setGuardando']),
        async nuevoTimer(){
            await this.setNuevoTimer(this.clienteSeleccionado);
            this.clienteSeleccionado = {};

            this.setLoading(true);           
            try {
                let respuesta = await axios.post('/api/arditimers', this.timerNuevo).catch(error => { console.log(error); }); //AÑADIMOS EL TIMER A LA BDD
                this.timerNuevo.id = respuesta.data.id;
                
                respuesta = await axios.get(`/api/contratos?codCliente=${this.timerNuevo.idCliente}`) //RECUPERAR CONTRATOS DEL CLIENTE
                this.timerNuevo.contratos = respuesta.data.filter(c => c.activo === true);
                // this.timerNuevo.contratos = this.timerNuevo.contratos.filter(c => c.bolsa !== 0);

                this.timers.unshift(this.timerNuevo);
                this.setTimers(this.timers);

                this.dialogEscogerCliente = false;
                this.setLoading(false);
            } catch (error) {
                this.dialogEscogerCliente = false;
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos'
                });
            }

            this.tab = 0; //redirigimos a la tab del dia de hoy       
        },
        imputarTodosTimers(){
            let imputarTodos = false;
            this.timers.forEach(timer => {
                if (timer.hora > 0 || timer.minuto >= 5){
                    this.setTabConTimerActivo('parado');
                    this.setImputarTodos(true);
                    this.setIdTimerActivo(timer.id);
                    this.setCargarDatosDialog(true);
                    this.primeroImputarTodos = true;
                    imputarTodos = true;
                }
            });
            if(imputarTodos == false){
                this.setSnackbar({
                    tipo: 'warning',
                    mensaje: 'Para poder utilizar esta opción mínimo se necesita un timer con tiempo mayor a 5 minutos'
                });
            }
        },
        guardar(){
            // this.setCopiaCantidadTimersTotal(this.cantidadTimersTotal);
            this.setAutoGuardado(!this.autoGuardado);    
        },
        asignarTabTimerActivo(timer, caso){ //guardamos el nombre de la tab que contiene el timer activo
            if (timer.id === this.idTimerActivo && this.contieneTimerActivo !== 'parado'){
                this.setTabConTimerActivo(caso);
            }
        },
        redireccionTab(caso){
            if(caso !== 'hoy' && this.splitTimers('hoy')[2] !== 0){
                this.tab = 0;
            }
            else if(caso !== 'ayer' && this.splitTimers('ayer')[2] !== 0){
                this.tab = 1;
            }
            else {
                this.tab = 2;
            }
        },
        async nuevoTimerGrupo(){
            await this.setNuevoTimerGrupo(this.grupoSeleccionado);
            this.grupoSeleccionado = {};
            
            this.setLoading(true);
            try {
                let respuesta = await axios.post('/api/arditimersGrupos', this.timerNuevo).catch(error => { console.log(error); }); //AÑADIMOS EL TIMER A LA BDD
                this.timerNuevo.id = respuesta.data.id + 'g';
                
                this.timersGrupos.unshift(this.timerNuevo);
                this.setTimersGrupo(this.timersGrupos);

                this.dialogEscogerGrupo = false; 
                this.setLoading(false);
            } catch (error) {
                this.dialogEscogerGrupo = false; 
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos'
                });
            }

            this.tab = 0; //redirigimos a la tab del dia de hoy
        },
        ejecutarFoco(input){
            this.$nextTick(() => {
                this.$refs[input].focus();
            });
        },
        pressEnter () {
            // if(this.dialogEscogerCliente == true && !this.$v.clienteSeleccionado.$invalid){
            //     this.nuevoTimer();
            // }
            // if(this.dialogEscogerGrupo == true && !this.$v.grupoSeleccionado.$invalid){
            //     this.nuevoTimerGrupo();
            // }
            
            if(this.dialogEscogerCliente == true || this.dialogEscogerGrupo == true){
                this.$nextTick(() => {
                    this.$refs.anadir.$el.focus();
                });
            }
        },
        handleKeys() {
            if (event.keyCode === 83 && event.ctrlKey) { //Si se pulsa ctrl+S 
                event.preventDefault(); // cancelamos la accion por defecto del navegador
                // if(this.guardando == false){
                    this.guardar(); // Guardamos los timers
                    // this.setGuardando(true);
                // }
            }
        },
    },
    components: {
        'timer': Timer,
        'fulldialog': FullDialog,
        'timerGrupo': TimerGrupo,
        'fulldialogTimergrupo': FullDialogTimerGrupo
    },
    validations: {
      clienteSeleccionado: { required },
      grupoSeleccionado: { required }
    },
    computed: {
        ...mapState('arditimer', ['timers', 'timersGrupos', 'dialog', 'dialogG', 'autoGuardado', 'horaGuardado', 'idTimerActivo', 'contieneTimerActivo', 'imputarTodos', 'cargarDatosDialog', 'timerNuevo', 'cantidadTimersTotal', 'guardando']),
        ...mapState("login", ["authUser"]),
        splitTimers(){
            return (caso) => {
                let dateHoy = new Date;
                let dateAyer = new Date(dateHoy);
                dateAyer.setDate(dateHoy.getDate() - 1);
                let fechaHoy = dateHoy.getFullYear()+'-' + ((dateHoy.getMonth()+1) < 10 ? '0'+(dateHoy.getMonth()+1) : (dateHoy.getMonth()+1))+'-' + (dateHoy.getDate() < 10 ? '0'+dateHoy.getDate() : dateHoy.getDate());
                let fechaAyer = dateAyer.getFullYear()+'-' + ((dateAyer.getMonth()+1) < 10 ? '0'+(dateAyer.getMonth()+1) : (dateAyer.getMonth()+1))+'-' + ((dateAyer.getDate()) < 10 ? '0'+(dateAyer.getDate()) : dateAyer.getDate());
               
                let cuenta = 0;
                let timers = [];
                let timersGrupos = [];

                let todosTimers = this.timers.concat(this.timersGrupos);
                todosTimers.forEach(timer => {
                    switch (caso) {
                        case 'hoy':
                            if(timer.fecha === fechaHoy){
                                if(timer.idCliente){
                                    timers.push(timer);
                                }else{
                                    timersGrupos.push(timer);
                                }
                                cuenta++;
                                this.asignarTabTimerActivo(timer, 'hoy')
                            }
                            if(timer === todosTimers[todosTimers.length-1] && cuenta === 0 && this.tab === 0){ //redireción de tab cuando la tab actual se queda sin timers
                                this.redireccionTab('hoy');
                            }
                            break;
                        case 'ayer':
                            if(timer.fecha === fechaAyer){
                                if(timer.idCliente){
                                    timers.push(timer);
                                }else{
                                    timersGrupos.push(timer);
                                }
                                cuenta++;
                                this.asignarTabTimerActivo(timer, 'ayer')
                            } 
                            if(timer === todosTimers[todosTimers.length-1] && cuenta === 0 && this.tab === 1){
                                this.redireccionTab('ayer');
                            }
                            break;
                        case 'anteriores':
                            if(timer.fecha < fechaAyer){
                                if(timer.idCliente){
                                    timers.push(timer);
                                }else{
                                    timersGrupos.push(timer);
                                }
                                cuenta++;                                
                                this.asignarTabTimerActivo(timer, 'anteriores')
                            }
                            if(timer === todosTimers[todosTimers.length-1] && cuenta === 0 && this.tab === 2){
                                this.redireccionTab();
                            }
                            break;
                    }
                });
                return [timers, timersGrupos, cuenta];
            }
        }
    },
    created() {
        // Controlar el cierre o recarga de la página
        this.eventoCierre = (event) => {
            this.guardar();
            event.returnValue = "";
        };
        window.addEventListener("beforeunload", this.eventoCierre);
    },
    async mounted() {
        this.setLoading(true);
        try{
            //LISTAR LOS CLIENTES DE LA BDD
            let respuesta = await axios.get('/api/clientes'); 
            this.clientes = respuesta.data;
            
            //LISTAR TIMERS BDD
            respuesta = await axios.get('/api/arditimers'); 
            let timersBBDD = respuesta.data;
            timersBBDD.forEach(timer => { //añadimos mas datos al timer 
                    let cliente = this.clientes.find(c => c.code === timer.idCliente);
                    if(cliente){
                        timer.cliente = cliente.name;
                        timer.comercialCliente = cliente.comercialEmail;
                        timer.contratos = {};
                        axios.get(`/api/contratos?codCliente=${timer.idCliente}`).then(respuesta => { //RECUPERAR CONTRATOS DE CADA CLIENTE
                            timer.contratos = respuesta.data.filter(c => c.activo === true);
                            // timer.contratos = timer.contratos.filter(c => c.bolsa !== 0);
                        }).catch(error =>{
                            this.setSnackbar({
                                tipo: 'error',
                                mensaje: 'Error. No se han podido recuperar los datos'
                            });
                        });

                        timer.observaciones = cliente.observaciones;
                        // timer.obsUsuarioModificacion = cliente.obsUsuarioModificacion;
                        // timer.obsFechaModificacion = cliente.obsFechaModificacion;
                        timer.invalido = false;
                    }else{
                        timer.cliente = 'CLIENTE NO ENCONTRADO!'
                        timer.comercialCliente = {};
                        timer.contratos = [];
                        timer.observaciones = 'EL CLIENTE NO SE HA PODIDO RECUPERAR';
                        timer.invalido = false;
                        timer.noExiste = true;
                    }
            });
            //LISTAR LOS GRUPOS DE LA BDD
            respuesta = await axios.get('/api/gruposaccionesmasivas'); 
            let gruposPublicos = respuesta.data.filter(g => g.publico == 0);
            let gruposPribasdos = respuesta.data.filter(g => g.publico == 1);
            if(gruposPublicos.length != 0){
                this.grupos.push({ header: 'Grupos Privados'});
                gruposPublicos.forEach(grupo => {
                    this.grupos.push(grupo);
                });
            }
            if(gruposPribasdos.length != 0){
                if(gruposPublicos.length != 0){ this.grupos.push({ divider: true });}
                this.grupos.push({ header: 'Grupos Públicos' });
                gruposPribasdos.forEach(grupo => {
                    this.grupos.push(grupo);
                });
            } 

            //LISTAR TIMERS GRUPOS BDD
            respuesta = await axios.get('/api/arditimersGrupos');
            let timersGruposBBDD = respuesta.data;
            timersGruposBBDD.forEach(timer => { //añadimos mas datos al timer 
                let grupo = this.grupos.filter(g => g.id === timer.idGrupo)[0];
                timer.grupo = grupo;
                timer.id = timer.id + 'g';
            });
            
            //LISTAR CONTRATOS BDD
            respuesta = await axios.get('/api/contratos');
            this.contratos = respuesta.data;

            this.setTimers(timersBBDD.reverse());
            this.setTimersGrupo(timersGruposBBDD.reverse());

            this.setLoading(false);
        } catch (error) {
            this.setLoading(false);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se han podido recuperar los datos'
            });
        }
        
        this.interval = setInterval(() => { //cada 5 minutos guardamos los datos en la BBDD
            this.guardar();
        },300000);
        
        window.addEventListener('keydown', this.handleKeys);
    },
    beforeDestroy(){
        // this.setCopiaCantidadTimersTotal(this.cantidadTimersTotal);
        this.setTabConTimerActivo('');
        window.removeEventListener("beforeunload", this.eventoCierre);
        window.removeEventListener('keydown', this.handleKeys);
    },
    destroyed() {
        this.timers.length = 0;
        this.setTimers(this.timers);
        this.timersGrupos.length = 0;
        this.setTimersGrupo(this.timersGrupos);
        // this.setCantidadTimersTotal(0);
    },
    watch: {
        async cargarDatosDialog(){
            if(this.cargarDatosDialog == true){//RECUPERO TODOS LOS DATOS NECESSRIOS PARA EL FULLDIALOG
                this.setLoading(true);

                this.timer = this.timers.filter(timer => { //filtro el timer que tiene una id igual al id del timer activo y lo guardo
                    return timer.id === this.idTimerActivo     
                })[0];
                
                try {
                    let params = {
                        idsEstadosParteSeleccionados: [1],
                        cliente: [this.timer.idCliente],
                    }
                    
                    let respuesta = await axios.get('/api/partes', { params }); //LISTAR PARTES BDD que corresponden al cliente y estan activos
                    this.partes = respuesta.data; 
                    let general = false;
                    this.partes.forEach(parte => {
                        if(parte.user.name == 'GENERAL'){
                            general = true;
                            this.timer.parteInicial = parte.id;
                        }
                        if(parte.user.id == this.authUser.id && general == false){
                            this.timer.parteInicial = parte.id;
                        }
                    });
                    if(this.timer.parteInicial == undefined && this.partes.length >= 1){
                        this.timer.parteInicial = this.partes[0].id;
                    }
                    
                    
                    //obtener delegaciones del cliente
                    respuesta = await axios.get(`/api/delegaciones?codCliente=${this.timer.idCliente}`);
                    this.delegaciones = respuesta.data;
                    
                    // respuesta = await axios.get(`/api/contratos?codCliente=${this.timer.idCliente}`);//LISTAR CONTRATOS BDD
                    // this.contratos = respuesta.data;
                    // this.contratos = this.contratos.filter(c => c.activo === true);
                    // console.log(this.contratos);
                    this.contratos = this.timer.contratos;
                    
                    this.timer.fechaFD = this.timer.fecha;

                    this.timer.inicioTimerFD = this.timer.horaInicio.split(":"); //separo la hora en un array para cambiar el formato hh:mm:ss
                    let minutos = ((Math.ceil((this.timer.inicioTimerFD[1])/15)))*15; //obligo a los minutos a ser multiple de 5
                    if(minutos === 60){
                        this.timer.inicioTimerFD = Number(this.timer.inicioTimerFD[0])+1 + ":00"; 
                    }else{
                        this.timer.inicioTimerFD = this.timer.inicioTimerFD[0] + ":" + (minutos < 10 ? '0' + minutos : minutos); //monto el array con el formato hh:mm 
                    }
                    
                    if (this.timer.contacto){
                        if(this.timer.comentarios){
                            this.timer.comentariosFD = 'Nos contacta '+this.timer.contacto+'. '+this.timer.comentarios
                        }else{
                            this.timer.comentariosFD = 'Nos contacta '+this.timer.contacto+'. ';
                        }
                    }else{
                        this.timer.comentariosFD = this.timer.comentarios;
                    }

                    // Cálculo de la hora fin (hora inicio + horaTimer y minuto inicio + minutoTimer)
                    let date = new Date(this.timer.fecha+' '+this.timer.inicioTimerFD);
                    date.setHours(date.getHours()+this.timer.hora);
                    date.setMinutes(date.getMinutes()+this.timer.minuto);
                    this.timer.finTimerFD = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours())+':' +(date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes());
                    

                    let horasTranscurridas = parseInt(this.timer.finTimerFD.substr(0, 2)) - parseInt(this.timer.inicioTimerFD.substr(0, 2));
                    let minutosTranscurridos = parseInt(this.timer.finTimerFD.substr(3, 2)) - parseInt(this.timer.inicioTimerFD.substr(3, 2));
                    

                    if(horasTranscurridas <= 0 && minutosTranscurridos < 5 || (horasTranscurridas <= 0 && minutosTranscurridos == 5 && this.timer.segundo < 15 )){
                        this.timer.finTimerFD = this.timer.inicioTimerFD;
                        this.timer.tiempoTotalFD = '00:00';
                    }else{ 
                        let minutos = this.timer.finTimerFD.substr(3,2);
                        if(this.timer.segundo > 15 ){
                            minutos++;
                        }
                        minutos = (Math.ceil(minutos/15))*15; //obligo a los minutos a ser multiple de 15

                        if(minutos === 60){ 
                            this.timer.finTimerFD = Number(this.timer.finTimerFD.substr(0, 2))+1 + ':00'; 
                        }else{
                            this.timer.finTimerFD = this.timer.finTimerFD.substr(0, 2) + ':' + (minutos < 10 ? '0' + minutos : minutos); 
                        }
                        
                        if(this.timer.inicioTimerFD.substr(0, 2).includes(':')){
                            this.timer.inicioTimerFD = '0'+this.timer.inicioTimerFD;
                        }

                        let horasTotales = this.timer.finTimerFD.substr(0, 2) - this.timer.inicioTimerFD.substr(0, 2);
                        let minutosTotales = this.timer.finTimerFD.substr(3, 2) - this.timer.inicioTimerFD.substr(3, 2);
                        
                        if(minutosTotales < 0){
                            minutosTotales = 60 + minutosTotales;
                            this.timer.tiempoTotalFD = (horasTotales <= 10 ? '0'+Number(horasTotales-1) : Number(horasTotales-1))+':' +(minutosTotales < 10 ? '0'+minutosTotales : minutosTotales);
                        }else{
                            this.timer.tiempoTotalFD = (horasTotales < 10 ? '0'+horasTotales : horasTotales-1)+':' +(minutosTotales < 10 ? '0'+minutosTotales : minutosTotales);
                        }
                        this.timer.invalido = false;
                    }
                    
                    
                    if(this.imputarTodos == false || (this.imputarTodos == true && this.primeroImputarTodos == true)){
                        this.primeroImputarTodos = false;
                        
                        let respuesta = await axios.get("/api/usuarios?grupo=2"); //LISTAR TECNICOS BDD
                        this.tecnicos = respuesta.data;

                        respuesta = await axios.get("/api/ambitos");//LISTAR AMBITOS BDD
                        this.ambitos = respuesta.data;

                        respuesta = await axios.get("/api/usuarios?grupo=3"); //LISTAR COMERCIALES BBDD
                        this.comerciales = respuesta.data;
                        
                        respuesta = await axios.get("/api/gradosurgencia");//LISTARA GRADO DE URGENCIA BDD
                        this.gradosurgencia = respuesta.data;
                        
                        if(this.delegaciones.length !== 0){
                            this.setDialog(true);
                        }else{
                            this.setSnackbar({
                                tipo: 'warning',
                                mensaje: 'El cliente ' + this.timer.cliente + ' no tiene delegaciones informadas en BC'
                            });
                        }
                    }
                   
                    this.setLoading(false);
                } catch (error) {
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se han podido recuperar los datos del timer'
                    });
                }
                this.setCargarDatosDialog(false);
            }
        }
    },
}
</script>

<style>
    .text-md-h6 {
        font-weight: 400 !important;
    }
    .v-textarea textarea {
        line-height: 1.5rem !important;
    }
    .v-card__title {
        word-break: break-word !important;
    }
    .infoGuardado{
        background-color: transparent !important;
        font-size: 50px;
        font-style: italic;
    }
    .parpadea {
        color: red !important;
        margin-left: 10px;
        animation-name: parpadeo;
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }
    @keyframes parpadeo {  
        0% { opacity: 1.0; }
        50% { opacity: 0.0; }
        100% { opacity: 1.0; }
    }
</style>